import { 
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile
} from "firebase/auth";
import { auth, appleProvider } from '../firebase';

export const signInWithApple = async () => {
  const result = await signInWithPopup(auth, appleProvider);
  return result.user;
};

export const signUpWithEmail = async (email, password, displayName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(userCredential.user, { displayName });
  return userCredential;
};

export const signInWithEmail = (email, password) => signInWithEmailAndPassword(auth, email, password);
